import React, { Component } from 'react'
import PropTypes from 'prop-types'

// MATERIAL
import { Dialog, DialogContent, DialogActions, FormControl, List, Paper, Stepper, Step, StepLabel, Grid, TextField } from '@material-ui/core';

// FUNCIONES GENERALES;
import AppBarModal from '../../general/AppBarModal';
import AlertasSimple from '../../general/AlertasSimple';
import TareasTerminadas from '../../general/TareasTerminadas';
import { BtnFormPage, BtnCargar } from '../../general/BotonesAccion';
import EnviarMultiplesArchivos from "../../general/EnviarMultiplesArchivos";
import { consulta, obtenerValoresFiltros, obtenerPermisosValorAlt, generarFiltros } from "../../../global/js/funciones";

// IMAGENES
import emma_w from '../../../global/imagenes/emma_w.png';

// HELPERS
import { EVIDENCIA } from '../Helpers';

// STEP
const configStep = ['Reto/Solución', 'Evidencia'];


function FormRetosSolucion(component_props) {
  let { pregunta_retos, solucion_reto, empresa_reto, url_solucion_reto, nombre_reto, mensaje_retos_solucion, setearEstado, estadoActual } = component_props
  return (
    <>
      <Grid container spacing={3} style={{ marginBottom: '40px' }}>
        {/* preguta reto */}
        <Grid item xs={12} >
          <FormControl className="form-control">
            <TextField
              value={pregunta_retos}
              id="pregunta_retos"
              label={"Pregunta  Retos"}
              name="pregunta_retos"
              placeholder={"Ingrese pregunta retos"}
              multiline={true}
              minRows={2}
              inputProps={{ style: { textTransform: "uppercase" } }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={({ target: { value } }) => setearEstado({ pregunta_retos: value })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} >
          <FormControl className="form-control">
            <TextField
              value={solucion_reto}
              id="solucion_reto"
              label={"Resumen entregable"}
              name="solucion_reto"
              placeholder={"Ingrese el resumen de esta etapa reto"}
              multiline={true}
              minRows={3}
              inputProps={{ style: { textTransform: "uppercase" } }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={({ target: { value } }) => setearEstado({ solucion_reto: value })}
            />
          </FormControl>
        </Grid>

        {estadoActual.estado_actual.codigo == 'Ret_Gru' &&
          <Grid item xs={12} >
            <FormControl className="form-control">
              <TextField
                value={empresa_reto}
                id="empresa_retos"
                label={"Ingrese Nombre Empresa Retos Unicosta"}
                name="pregunta_retos"
                placeholder={"Ingrese Nombre Empresa Reto"}
                multiline={true}
                minRows={2}
                inputProps={{ style: { textTransform: "uppercase" } }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={({ target: { value } }) => setearEstado({ empresa_reto: value })}
              />
            </FormControl>
          </Grid>
        }

        {estadoActual.estado_actual.codigo == 'Ret_Env' &&
          <Grid item xs={12} >
            <FormControl className="form-control">
              <TextField
                value={empresa_reto}
                id="empresa_retos"
                label={"Ingrese Nombre Empresa Retos Unicosta"}
                name="pregunta_retos"
                placeholder={"Ingrese Nombre Empresa Reto"}
                multiline={true}
                minRows={2}
                inputProps={{ style: { textTransform: "uppercase" } }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={({ target: { value } }) => setearEstado({ empresa_reto: value })}
              />
            </FormControl>
          </Grid>
        }

        {
          estadoActual.estado_actual.codigo == 'Ret_Cal_e3' &&
          <>
            <Grid item xs={12} >
              <FormControl className="form-control">
                <TextField
                  value={url_solucion_reto}
                  id="url_solucion_reto"
                  label={"Ingrese la URL del video - Presentación final"}
                  name="url_solucion_reto"
                  placeholder={"Ingrese la URL del video - Presentación final"}
                  multiline={true}
                  minRows={2}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={({ target: { value } }) => setearEstado({ url_solucion_reto: value })}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} >
              <FormControl className="form-control">
                <TextField
                  value={nombre_reto}
                  id="nombre_reto"
                  label={"Ingrese el nombre del reto"}
                  name="nombre_reto"
                  placeholder={"Ingresa el nombre del reto"}
                  multiline={true}
                  minRows={2}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={({ target: { value } }) => setearEstado({ nombre_reto: value })}
                />
              </FormControl>
            </Grid>
          </>
        }

        {/* Mensaje informativo de los Reto/Solucion */}
        <Grid item xs={12}>
          <AlertasSimple
            tipo='info'
            titulo={'Estimado estudiante, tener en cuenta: '}
            lista={mensaje_retos_solucion}
            margin='0px'
          />
        </Grid>

      </Grid>
    </>
  )
}

function AttachComponent(component_props) {
  let { evidencia, mensaje_retos_evidencia, submit } = component_props

  const trasnformarDataAdj = (data) => {
    let r = [];
    data.map((evi) => r.push({ nombre: evi.nombre, descripcion: evi.descripcion, codigo: evi.id, archivo: evi.archivo }))
    return r;
  }

  const acciones = (data, callback) => {
    const onClickCargar = (data) => callback(data);

    let cargar = <BtnCargar callback={() => onClickCargar(data)} color='#00bfa5' texto='Gestionar' />
    return <div>{cargar}</div>;
  }

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper elevation={0} square>
            <List component="nav" arial-label="main">
              <EnviarMultiplesArchivos
                acciones={acciones}
                enModal={false}
                enviarArchivos={(archivos) => submit(archivos)}
                limite={2}
                mostrarMensaje={false}
                enLista={true}
                lista={trasnformarDataAdj(evidencia)}
              />
            </List>
          </Paper>
        </Grid>


        {/* Mensaje informativo Evidencia */}
        <Grid item xs={12}>
          <AlertasSimple
            tipo='info'
            titulo={'Estimado estudiante, tener en cuenta: '}
            lista={mensaje_retos_evidencia}
            margin='0px'
          />
        </Grid>
      </Grid>

    </React.Fragment>

  )
}


class RetosCrear extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeStep: 0,
      pregunta_retos: '',
      solucion_reto: '',
      empresa_reto: '',
      url_solucion_reto: '',
      evidencia: [],
      nombre_reto: '',
      cargar: true,
      titulo_carg: 'Cargando...',
    }
  }

  async componentDidMount() {
    this.obtenerDatos();
  }

  transformar = data => {
    return data.map(e => ({
      value: e.id,
      label: e.nombre,
      codigo: e.codigo
    }));
  }


  obtenerRetoscuc(id) {
    return new Promise(async (resolve) => {
      let f = await generarFiltros([{ 'llave': 'id', 'valor': id }]);
      consulta(`api/v1.0/retos/${f}`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && resp.length > 0 ? resp[0] : null);
      })
    })
  }


  async obtenerDatos() {
    this.setState({ cargando: true })
    let informativo_retos_solucion = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Ret_Info_Sol' }]);
    let informativo_retos_evidencia = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Ret_Info_Evi' }]);
    let evidencia = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Evi_Ret_Sol' }]);

    this.setState({ evidencia, cargando: false, informativo_retos_solucion: informativo_retos_solucion.length > 0 ? informativo_retos_solucion[0].descripcion : '', informativo_retos_evidencia: informativo_retos_evidencia.length > 0 ? informativo_retos_evidencia[0].descripcion : '' });
  }

  agregarArchivos = files => {
    let { actualizarMensaje } = this.props
    let { archivos, evidencia } = this.state
    files.map((archivo => {
      if (archivos.length === 10000) actualizarMensaje({ titulo: `Se ha superado el numero maximo de archivos ${evidencia.length}`, tipo: 'info', mostrar: true, tiempo: 6000 })
      else archivos.push(archivo)
    }))
    this.setState({ archivos })
  }

  eliminarArchivo = (i) => {
    let { actualizarMensaje } = this.props;
    let { archivos } = this.state;
    archivos.splice(i, 1)
    this.setState({ archivos })
    actualizarMensaje({ titulo: `Archivo Retirado.`, tipo: 'success', mostrar: true, tiempo: 6000 })
  }

  reiniciarEstado() {
    this.setState({
      activeStep: 0,
      cargando: false,
      titulo_carg: 'Cargando...',
    })
  }

  // STEPER
  handleStep = direction => {
    let { actualizarMensaje, estadoActual } = this.props
    let { activeStep, pregunta_retos, solucion_reto, empresa_reto, url_solucion_reto } = this.state
    let sw = true

    if (estadoActual.estado_actual.codigo == 'Ret_Env' && !empresa_reto) {
      actualizarMensaje({ titulo: 'Debe diligenciar todos los campos obligatorios para continuar', tipo: 'info', mostrar: true, tiempo: 6000 });
      sw = false
    }

    if (estadoActual.estado_actual.codigo == 'Ret_Cal_e3' && !url_solucion_reto) {
      actualizarMensaje({ titulo: 'Debes cargar URL de la presentación final', tipo: 'info', mostrar: true, tiempo: 6000 });
      sw = false
    }

    if ((!pregunta_retos || !solucion_reto) && activeStep == 0) {
      actualizarMensaje({ titulo: 'Debe diligenciar todos los campos obligatorios para continuar', tipo: 'info', mostrar: true, tiempo: 6000 });
      sw = false
    }

    if (sw) this.setState({ activeStep: direction ? activeStep + 1 : activeStep - 1 })
  }


  // OBTENER EVIDENCIA DE RETOS
  obtenerEvidencia = async () => {
    this.setState({ cargando: true })
    // let { estado } = this.state
    let evidencia = await obtenerPermisosValorAlt([{ 'llave': 'secundario__generica', 'valor': EVIDENCIA }, { 'llave': 'secundario__valora', 'valor': 'estudiante' }])
    this.setState({ cargando: false, evidencia })
  }

  // ENVIAR DATOS 
  enviarDatosRetos = async (archivos) => {
    let { actualizarMensaje, guardarRetos, retoscuc_id } = this.props
    let { pregunta_retos, solucion_reto, empresa_reto, url_solucion_reto, nombre_reto } = this.state
    let total = archivos.length
    if (archivos.length > 0) {
      this.setState({ cargando: true, tit_cargando: 'Enviando..' })
      let data = { pregunta_retos, total, solucion_reto, empresa_reto, url_solucion_reto, nombre_reto }
      guardarRetos(archivos, data, retoscuc_id, (resp) => this.reiniciarEstado(resp))
    } else actualizarMensaje({ titulo: 'Debe adjuntar un archivo por cada requisito obligatorio.', tipo: 'info', mostrar: true, tiempo: 6000 });
  }

  // ENVIAR EVIDENCIA ACUTLIZADA
  enviarActulizarEvidenciaRetos = async (archivos) => {
    let { actualizarMensaje, actualizarEvidenciaRetos, retoscuc_id } = this.props
    let total_evidencia = archivos.length
    if (archivos.length > 0) {
      this.setState({ cargando: true, tit_cargando: 'Enviando..' })
      let data = { total_evidencia }
      actualizarEvidenciaRetos(archivos, data, retoscuc_id, (resp) => this.reiniciarEstado(resp))
    } else actualizarMensaje({ titulo: 'Debe adjuntar un archivo por cada requisito obligatorio.', tipo: 'info', mostrar: true, tiempo: 6000 })
  }

  configStepContent = () => {
    let { activeStep, initialTransition, pregunta_retos, solucion_reto, empresa_reto, url_solucion_reto, nombre_reto, archivos, evidencia, informativo_retos_solucion, informativo_retos_evidencia, actualizarMensaje } = this.state

    let { estadoActual } = this.props

    let mensaje_retos_solucion = [{ item: informativo_retos_solucion }]
    let mensaje_retos_evidencia = [{ item: informativo_retos_evidencia }]
    switch (activeStep) {

      case 0:
        return (
          <FormRetosSolucion
            {...{
              pregunta_retos,
              solucion_reto,
              mensaje_retos_solucion,
              empresa_reto,
              url_solucion_reto,
              nombre_reto,
              onChange: this.onChange,
              setearEstado: (estado) => this.setState(estado),
              estadoActual
            }}
          />
        )

      case 1:
        return (
          <>
            <AttachComponent
              {...{
                initialTransition,
                evidencia,
                archivos,
                actualizarMensaje,
                mensaje_retos_evidencia,
                eliminarArchivo: this.eliminarArchivo,
                agregarArchivos: this.agregarArchivos,
                submit: this.enviarDatosRetos || this.enviarActulizarEvidenciaRetos
              }}
            />
          </>
        )
      default:
        return <TareasTerminadas imagen={emma_w} mensaje='Esta bandeja esta vacía' widthImg='10%' marginTop='10%' />
    }
  }


  render() {
    let { modalAddRetos, mostrarModalAddRetos } = this.props
    let { cargando, titulo_carg, activeStep, evidencia } = this.state

    return (
      <>
        <Dialog fullWidth={true} maxWidth="sm" open={modalAddRetos} onClose={() => mostrarModalAddRetos(false)}>
          <AppBarModal titulo={"¡ Nueva Solicitud !"} mostrarModal={() => mostrarModalAddRetos(false)} titulo_accion="Cerrar" accion={() => mostrarModalAddRetos(false)} />
          <DialogContent className='scroll'>
            {
              !cargando ?
                <Grid container>
                  <Grid item xs={12} md={12}>
                    <Stepper activeStep={activeStep}>
                      {
                        configStep.map(label => (
                          <Step key={label}>
                            <StepLabel><p>{label}</p></StepLabel>
                          </Step>
                        ))
                      }
                    </Stepper>
                  </Grid>

                  {this.configStepContent()}

                </Grid> :
                <TareasTerminadas mensaje={titulo_carg} marginTop='7%' imagen={emma_w} widthImg="7%" />
            }

          </DialogContent>
          <DialogActions>
            {activeStep > 0 ?
              <div>
                {
                  !cargando && (
                    <>
                    <BtnFormPage texto="ATRAS" callback={() => this.handleStep(false)} type="submit" />
                    <BtnFormPage texto="GUARDAR" callback={() => { document.getElementById('enviar_form_multi_archivo').click() }} type="submit" />
                  </>
                  )
                }
              </div>
              : <BtnFormPage texto="SIGUIENTE" callback={() => this.handleStep(true)} type="submit" />
            }
          </DialogActions>
        </Dialog >
      </>
    )
  }
}

RetosCrear.propsTyps = {
  modalAddRetos: PropTypes.bool.isRequired,
  actulizarMensaje: PropTypes.bool.isRequired,
}

export default RetosCrear